import styled from 'styled-components';
import { unthemed, zIndex } from '../../tokens';

interface UIProps {
	isDropTarget: boolean;
}
export const UI = styled.div<UIProps>`
	position: absolute;
	width: 100%;
	height: 100%;
	overflow: hidden;
	z-index: ${zIndex.ui};
`;

export const HandTool = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	overflow: hidden;

	cursor: grabbing;
`;

export const SelectionBox = styled.div`
	outline: 2px solid ${unthemed.blue['700']};
	position: absolute;
	box-sizing: border-box;
	pointer-events: none;
`;

export const ZoomPreviewBox = styled.div`
	position: absolute;
	box-sizing: border-box;
	pointer-events: none;
	outline: 2px solid ${unthemed.blue['700']};
	background: ${unthemed.blue['500']}44;
`;

export const SelectionBoundingBox = styled(SelectionBox)`
	outline: 1px solid ${unthemed.blue['600']};
`;

export const HoverBox = styled(SelectionBox)`
	outline: 2px solid ${unthemed.blue['600']};
`;

export const DimensionsBox = styled.div`
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	pointer-events: none;
	gap: 4px;
`;

export const Dimensions = styled.div`
	background: ${unthemed.blue['500']};
	pointer-events: none;
	font-size: 11px;
	font-weight: 600;
	color: ${unthemed.gray['0']};
	margin-top: 5px;
	display: inline-block;
	padding: 0px 3px;
	border-radius: 3px;
`;

export const ActionsBox = styled.div`
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	pointer-events: none;
	gap: 4px;
	margin-top: 6px;
`;

interface ActionProps {
	disabled?: boolean;
}

export const Action = styled.div<ActionProps>`
	background: ${unthemed.blue['500']};
	pointer-events: auto;
	color: ${unthemed.gray['0']};
	display: inline-block;
	padding: 0px 4px;
	border-radius: 3px;
	opacity: ${(props) => (props.disabled ? 0.4 : 0.8)};
	&:hover {
		opacity: ${(props) => (props.disabled ? 0.4 : 1)};
	}
	&:active {
		opacity: ${(props) => (props.disabled ? 0.4 : 0.8)};
	}
`;

interface RetryButtonProps {
	scale?: number;
}
export const RetryButton = styled.button<RetryButtonProps>`
	// layout
	position: absolute;
	box-sizing: border-box;
	z-index: 1000;

	// styles
	font-size: ${(props) => (props.scale || 1) * 40}px;
	font-weight: 600;
	background: transparent;
	border-radius: ${(props) => (props.scale || 1) * 3}px;
	cursor: pointer;

	border: ${(props) => (props.scale || 1) * 1}px solid ${unthemed.gray['400']};
	color: ${unthemed.gray['600']};

	&:hover {
		border: ${(props) => (props.scale || 1) * 1}px solid ${unthemed.gray['100']};
		color: ${unthemed.gray['100']};
	}
`;

interface RespawnButtonProps {
	scale?: number;
}
export const RespawnButton = styled.button<RespawnButtonProps>`
	// layout
	position: absolute;
	padding-top: 3px;

	// styles
	background: transparent;
	cursor: pointer;
	border: 0px solid ${unthemed.gray['700']};
	background: ${unthemed.gray['1000']}B0;

	&:hover {
		background: ${unthemed.gray['1000']}90;
	}
`;
